
































import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
    props: {
        title: {
            type: String,
            default: '温馨提示'
        },
        message: {
            type: String,
            default: ''
        },
        confirmButtonText: {
            type: String,
            default: '确定'
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        text: {
            type: String,
            default: ''
        },
        inputValue: {
            type: String,
            default: ''
        },
        cancelCallBack: {
            type: Function,
            default() {}
        },
        confirmCallBack: {
            type: Function,
            default() {}
        },
        oneBtnCallBack: {
            type: Function,
            default() {}
        }
    }
})
export default class Dialog extends Vue {
    visible: boolean = false;
    showOneBtn: boolean = false;
    showTitle: boolean = true;
    showInput: boolean = false;
    useText: boolean = false;
    activeBtn: boolean = false;
    showInputTestError: boolean = false;
    cancel(): void {
        let { cancelCallBack } = this.$props;
        cancelCallBack && cancelCallBack();
    }
    confirm(): void {
        let { confirmCallBack, inputValue } = this.$props;
        confirmCallBack && confirmCallBack(inputValue);
    }
    oneBtn(): void {
        let { oneBtnCallBack } = this.$props;
        oneBtnCallBack && oneBtnCallBack();
    }
    changeBtnColor(): void {}
};
